<template>
	<div id="editsystemtext">
        <div class="row ">
	        <div class="col-12">
				<el-form ref="editsystemtextform" :model="details" label-position="top" label-width="120px" @submit.native.prevent >
					<el-form-item :label="(isHelp ? 'Help Page:' : 'System Text:')" prop="SystemTextID">
						<el-select v-if="isHelp" v-model="SystemTextID" class="topDropdown" size="default" placeholder="Select" @change="getSystemText" default-first-option filterable>
							<el-option
									v-for="item in (isHelp ? helpAreas : emails)"
									:key="item.SystemTextID"
									:label="item.SystemTextName"
									:value="item.SystemTextID">
							</el-option>
						</el-select>
						<el-select  v-else size="default" v-model="SystemTextID" class="topDropdown" placeholder="Select" @change="getSystemText" default-first-option filterable clearable>
							<el-option-group
									v-for="areas in textAreas"
									:key="areas.SystemTextType"
									:label="areas.SystemTextType">
								<el-option
										v-if="createAccess && areas.SystemTextType == 'Custom Emails' " label="-- Add New --" value=""> </el-option>
								<el-option
										v-for="items in areas.Entries"
										:key="items.SystemTextID"
										:label="items.SystemTextName"
										:value="items.SystemTextID">
								</el-option>
							</el-option-group>
						</el-select>
					</el-form-item>

					<el-form-item v-if="details.SystemTextType == 'C' && !isHelp"  size="default" key="" label="Custom Email Name:" prop="SystemTextName" :rules="[{ required: true, message: 'Email Name is required', trigger: 'blur'}]">
						<el-input v-model="details.SystemTextName" >
						</el-input>
					</el-form-item>

					<el-form-item v-if="details.SystemTextType == 'C' && !isHelp" label="Custom Email Type" prop="CustomTextID"
								  :rules="[{ required: true, message: 'Custom Email Type is required', trigger: 'blur'}]">
						<el-select v-model="details.CustomTextID" class="topDropdown" size="default" placeholder="Select Email Type" default-first-option filterable>
							<template v-for="item in CustomTextIDs" >
                                <el-option
									v-if="item.AllowCustom"
									:key="item.SystemTextID"
									:label="item.SystemTextName"
									:value="item.SystemTextID">
							    </el-option>
                            </template>
						</el-select>
					</el-form-item>

					<el-form-item v-if="details.SystemTextType == 'E' || details.SystemTextType == 'C' " label="Subject:" prop="Params.Subject"
								  :rules="[{ required: true, message: 'Email subject is required', trigger: 'blur'}]">
						<el-input v-model="details.Params.Subject" size="default">
						</el-input>
					</el-form-item>

					<el-form-item v-if="isHelp" label="On Page Message" prop="PageText">
                        <el-input type="textarea" :rows="10" v-model="details.Params.PageText">
                        </el-input>
					</el-form-item>
					<el-form-item :label="(isHelp ? 'Help Text:' : 'System Text:')" prop="SystemText">
                        <el-input type="textarea" :rows="10" v-model="details.SystemText">
                        </el-input>
					</el-form-item>
				</el-form>
			</div>
        </div>
		<div class="row" v-if="(modifyAccess || (createAccess && SystemTextID))" >
			<div class="col-12 text-center">
				<button class="btn btn-success btn-icon" @click="save" style="margin-right: 10px;">
					<i class="fas fa-check"></i> <span> Save Changes</span>
				</button>
				<button v-if="details.SystemTextType == 'C' && details.SystemTextID != '' " class="btn btn-success btn-icon" @click="saveAsNewText" style="margin-right: 10px;">
					<i class="fas fa-plus-circle"></i> <span> Save As New</span>
				</button>
				<button v-if="details.SystemTextType == 'C' && details.SystemTextID != '' " class="btn btn-icon btn-danger delete"  @click="cnfmDeleteSystemText()" style="margin-right: 10px;">
					<i class="fas fa-trash"></i>  <span>Delete</span>
				</button>
				<button class="btn btn-icon btn-dark cancel"  @click="reset(true)">
					<i class="fas fa-times"></i>  <span>Cancel</span>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import axios from 'axios';
	import nav from '../nav';
    import Util from "@/assets/js/util";

	const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;

	export default {
		data() {
			return {
				SystemTextID: '',
				helpAreas: [],
				textAreas: [{
					SystemTextType: 'Emails', Entries: [
						{SystemTextID: 'welcome', SystemTextName: 'Welcome to the Site', AllowCustom: true},
						{SystemTextID: 'forgot', SystemTextName: 'Forgot Password', AllowCustom: false},]
				},

					{
						SystemTextType: 'Custom Emails', Entries: []
					},

					{
						SystemTextType: 'Text', Entries: [
							{SystemTextID: 'loginwelcome', SystemTextName: 'Login Page Welcome'},
							{SystemTextID: 'dashboard', SystemTextName: 'Dashboard Message'},
						]
					},
				],
				SystemTextType: '',
				details: {SystemTextID : '', SystemTextType : '', SystemTextName : '', SystemText : '', CustomTextID : '',Params : {}},
			}
		},
		name: 'SystemText',
		computed: {
			...mapGetters({currentUser: 'currentUser'}),
			...mapGetters({componentIDs: 'componentIDs'}),
			isInitial() {
				return this.currentStatus === STATUS_INITIAL;
			},
			isSaving() {
				return this.currentStatus === STATUS_SAVING;
			},
			isSuccess() {
				return this.currentStatus === STATUS_SUCCESS;
			},
			isFailed() {
				return this.currentStatus === STATUS_FAILED;
			},
            createAccess () {
                return Util.createAccess(this.currentUser);
            },
            modifyAccess () {
                return Util.modifyAccess(this.currentUser);
            },
			isHelp() {
				return (this.$route.fullPath.indexOf('help') !== -1 ? true : false);
			},
			isEmail() {
				return (this.$route.fullPath.indexOf('email') !== -1 ? true : false);
			},
			CustomTextIDs () {
				return this.textAreas[0].Entries;
			}
		},
		methods: {
			getCustomEmails () {

				axios.post('/systemtext/getcustomemails'
				)
					.then(response => {
						if (response.data.result == 'success') {
							if (response.data.CustomEmails) {
								this.textAreas[1].Entries = response.data.CustomEmails;
							}
						} else {
						}
					}).catch(response => {;
				});
			},
			getSystemText() {
				if (this.SystemTextID) {
					var self = this;
					axios.post('/systemtext/get', {
                        SystemTextID : this.SystemTextID,
                        Calling : 'SystemText' }
					)
							.then(response => {
								if (response.data.result == 'success') {
									if (response.data.SystemText) {
										this.details = response.data.SystemText;
									} else {
										//new so build empty object
										if (this.isHelp) {
											for (let i = 0; i < this.helpAreas.length; i++) {
												if (this.helpAreas[i].SystemTextID == this.SystemTextID) {
													this.details = {
														SystemTextID: this.SystemTextID,
														SystemTextType: 'H',
														SystemTextName: this.helpAreas[i].SystemTextName,
														SystemText: '',
														Params: {}
													};
													break;
												}
											}
										} else {
											for (let i = 0; i < this.textAreas.length; i++) {
												for (let j = 0; j < this.textAreas[i].Entries.length; j++) {
													if (this.textAreas[i].Entries[j].SystemTextID == this.SystemTextID) {
														this.SystemTextType = this.textAreas[i].SystemTextType;
														var SystemTextName = this.textAreas[i].Entries[j].SystemTextName;
														break;
													}
												}
											}
											this.details = {
												SystemTextID: this.SystemTextID,
												SystemTextType: this.SystemTextType.substring(0, 1),
												SystemTextName: SystemTextName,
												SystemText: '',
												Params: {}
											};
										}
									}

									let ID = (this.isHelp ? 'H-' : 'E-') + 'SystemTextID';
									let values = {}
									values[ID] = this.details.SystemTextID;
									self.$store.dispatch('setID', values);
								} else {
								}
							}).catch(response => {
					});
				} else {
					this.details = {
						SystemTextID: '',
						SystemTextType: 'C',
						SystemTextName: '',
						SystemText: '',
						CustomTextID : '',
						Params: {}
					};
				}
			},
			buildPageList() {
				this.helpAreas = [];
				for (let i = 0; i < nav.items.length; i++) {
					if (nav.items[i].name && nav.items[i].url && nav.items[i].name != 'Analyzer Software') {
						this.helpAreas.push({SystemTextName: nav.items[i].name, SystemTextID: nav.items[i].url});
					} else if (nav.items[i].children && nav.items[i].children.length > 0) {
						for (let j = 0; j < nav.items[i].children.length; j++) {
							if (nav.items[i].children[j].name && nav.items[i].children[j].url) {
								this.helpAreas.push({
									SystemTextName: nav.items[i].children[j].name,
									SystemTextID: nav.items[i].children[j].url
								});
							}
						}
					}
				}
				this.helpAreas.sort(function (a, b) {
					if (a.SystemTextName.toUpperCase() > b.SystemTextName.toUpperCase()) {
						return 1;
					} else if (a.SystemTextName.toUpperCase() < b.SystemTextName.toUpperCase()) {
						return -1;
					} else {
						return 0
					}
				});
			},

			saveAsNewText () {
				this.details.SystemTextID = '';
				this.save();
			},

			isDuplicate () {
				for (let i = 0; i < this.textAreas.length; i++) {
					for (let j = 0; j < this.textAreas[i].Entries.length; j++) {
						if (this.textAreas[i].Entries[j].SystemTextID != this.details.SystemTextID && this.textAreas[i].Entries[j].SystemTextName.toLowerCase() == this.details.SystemTextName.toLowerCase().trim()) {
							return true;
						}
					}
				}
				return false;
			},

			cnfmDeleteSystemText() {
				this.$confirm('This will permanently delete this System Text. Continue?', 'Warning', {
					confirmButtonText: 'OK',
					cancelButtonText: 'Cancel',
					type: 'warning'
				}).then(() => {
					this.deleteSystemText();
				}).catch(() => {
				});
			},
			deleteSystemText () {
				if (this.currentStatus == STATUS_SAVING) {
					return true;
				}
				this.currentStatus = STATUS_SAVING;
				let self = this;
				axios.post('/systemtext/delete', {'SystemTextID': this.SystemTextID}
				)
						.then(response => {
							if (response.data.result == 'success') {
								this.currentStatus = STATUS_INITIAL;
								let ID = (this.isHelp ? 'H-' : 'E-') + 'SystemTextID';
								let values = {};
								values[ID] = '';
								self.$store.dispatch('setID', values);

								this.$notify({
									title: 'Success',
									message: "System Text has been deleted",
									type: 'success',
									duration: 1500,
									showClose: false
								});
								this.SystemTextID = '';
								this.getSystemText();

								this.getCustomEmails();

							} else {
								this.currentStatus = STATUS_FAILED;
								this.displayPopup (response.data.message);
							}
						}).catch(response => {
					this.currentStatus = STATUS_FAILED;
				});
			},

			save() {
				this.$refs['editsystemtextform'].validate((valid) => {
					if (valid) {
						if (!this.isDuplicate()) {
							if (this.currentStatus == STATUS_SAVING) {
								return true;
							}
							this.currentStatus = STATUS_SAVING;
							let self = this;
							axios.post('/systemtext/save', {details: this.details}
							)
									.then(response => {
										if (response.data.result == 'success') {
											this.currentStatus = STATUS_INITIAL;
											let ID = (this.isHelp ? 'H-' : 'E-') + 'SystemTextID';
											let values = {};

											if (response.data.SystemTextID) {
												this.SystemTextID = response.data.SystemTextID;
												this.details.SystemTextID = response.data.SystemTextID;
											}
											values[ID] = this.details.SystemTextID;
											self.$store.dispatch('setID', values);
											this.getCustomEmails();

											this.$notify({
												title: 'Success',
												message: "Text has been saved",
												type: 'success',
												duration: 1500,
												showClose: false
											});
										} else {
											this.currentStatus = STATUS_FAILED;
											this.displayPopup(response.data.message);
										}
									}).catch(response => {
								this.currentStatus = STATUS_FAILED;
							});
						} else {
							this.displayPopup('This Custom Email Name Already Exists.');
						}
					}
				});
			},
			displayPopup(message) {
				this.$alert(message, 'Error', {
					confirmButtonText: 'OK',
				});
			}
		},

		mounted() {
            if (this.isHelp) {
			    this.buildPageList();
			}

			let ID = (this.isHelp ? 'H-' : 'E-') + 'SystemTextID';
			if (this.componentIDs[ID]) {
				this.SystemTextID = this.componentIDs[ID];
			}
			this.getSystemText();
			this.getCustomEmails();
		}

	}
</script>

<style>
	#editsystemtext .el-table__row {
		font-weight: 800;
	}
</style>
